// extracted by mini-css-extract-plugin
export var legendIndicator = "_cn-1";
export var legendRight = "_cn-0";